import { EN_US } from '../languages/constants'
// import '../../store/types'

/**
 * @param {ReduxState} state redux state
 * @returns {String}
 */
export function selectLocale (state) {
  return !!state.page.get('locale', EN_US)
}

export default selectLocale
